export const COUNTRIES = [
  { code: 'AF', name: 'Afghanistan', coordinates: [33.9391, 67.7100] },
  { code: 'AL', name: 'Albania', coordinates: [41.1533, 20.1683] },
  { code: 'DZ', name: 'Algeria', coordinates: [28.0339, 1.6596] },
  { code: 'AD', name: 'Andorra', coordinates: [42.5063, 1.5218] },
  { code: 'AO', name: 'Angola', coordinates: [-11.2027, 17.8739] },
  { code: 'AG', name: 'Antigua and Barbuda', coordinates: [17.0608, -61.7964] },
  { code: 'AR', name: 'Argentina', coordinates: [-38.4161, -63.6167] },
  { code: 'AM', name: 'Armenia', coordinates: [40.0691, 45.0382] },
  { code: 'AU', name: 'Australia', coordinates: [-25.2744, 133.7751] },
  { code: 'AT', name: 'Austria', coordinates: [47.5162, 14.5501] },
  { code: 'AZ', name: 'Azerbaijan', coordinates: [40.1431, 47.5769] },
  { code: 'BS', name: 'Bahamas', coordinates: [25.0343, -77.3963] },
  { code: 'BH', name: 'Bahrain', coordinates: [26.0667, 50.5577] },
  { code: 'BD', name: 'Bangladesh', coordinates: [23.6850, 90.3563] },
  { code: 'BB', name: 'Barbados', coordinates: [13.1939, -59.5432] },
  { code: 'BY', name: 'Belarus', coordinates: [53.7098, 27.9534] },
  { code: 'BE', name: 'Belgium', coordinates: [50.5039, 4.4699] },
  { code: 'BZ', name: 'Belize', coordinates: [17.1899, -88.4976] },
  { code: 'BJ', name: 'Benin', coordinates: [9.3077, 2.3158] },
  { code: 'BT', name: 'Bhutan', coordinates: [27.5142, 90.4336] },
  { code: 'BO', name: 'Bolivia', coordinates: [-16.2902, -63.5887] },
  { code: 'BA', name: 'Bosnia and Herzegovina', coordinates: [43.9159, 17.6791] },
  { code: 'BW', name: 'Botswana', coordinates: [-22.3285, 24.6849] },
  { code: 'BR', name: 'Brazil', coordinates: [-14.2350, -51.9253] },
  { code: 'BN', name: 'Brunei', coordinates: [4.5353, 114.7277] },
  { code: 'BG', name: 'Bulgaria', coordinates: [42.7339, 25.4858] },
  { code: 'BF', name: 'Burkina Faso', coordinates: [12.2383, -1.5616] },
  { code: 'BI', name: 'Burundi', coordinates: [-3.3731, 29.9189] },
  { code: 'KH', name: 'Cambodia', coordinates: [12.5657, 104.9910] },
  { code: 'CM', name: 'Cameroon', coordinates: [7.3697, 12.3547] },
  { code: 'CA', name: 'Canada', coordinates: [56.1304, -106.3468] },
  { code: 'CV', name: 'Cape Verde', coordinates: [16.5388, -23.0418] },
  { code: 'CF', name: 'Central African Republic', coordinates: [6.6111, 20.9394] },
  { code: 'TD', name: 'Chad', coordinates: [15.4542, 18.7322] },
  { code: 'CL', name: 'Chile', coordinates: [-35.6751, -71.5430] },
  { code: 'CN', name: 'China', coordinates: [35.8617, 104.1954] },
  { code: 'CO', name: 'Colombia', coordinates: [4.5709, -74.2973] },
  { code: 'KM', name: 'Comoros', coordinates: [-11.6455, 43.3333] },
  { code: 'CG', name: 'Congo', coordinates: [-0.2280, 15.8277] },
  { code: 'CD', name: 'Congo (DRC)', coordinates: [-4.0383, 21.7587] },
  { code: 'CR', name: 'Costa Rica', coordinates: [9.7489, -83.7534] },
  { code: 'HR', name: 'Croatia', coordinates: [45.1000, 15.2000] },
  { code: 'CU', name: 'Cuba', coordinates: [21.5218, -77.7812] },
  { code: 'CY', name: 'Cyprus', coordinates: [35.1264, 33.4299] },
  { code: 'CZ', name: 'Czech Republic', coordinates: [49.8175, 15.4730] },
  { code: 'DK', name: 'Denmark', coordinates: [56.2639, 9.5018] },
  { code: 'DJ', name: 'Djibouti', coordinates: [11.8251, 42.5903] },
  { code: 'DM', name: 'Dominica', coordinates: [15.4150, -61.3710] },
  { code: 'DO', name: 'Dominican Republic', coordinates: [18.7357, -70.1627] },
  { code: 'EC', name: 'Ecuador', coordinates: [-1.8312, -78.1834] },
  { code: 'EG', name: 'Egypt', coordinates: [26.8206, 30.8025] },
  { code: 'SV', name: 'El Salvador', coordinates: [13.7942, -88.8965] },
  { code: 'GQ', name: 'Equatorial Guinea', coordinates: [1.6508, 10.2679] },
  { code: 'ER', name: 'Eritrea', coordinates: [15.1794, 39.7823] },
  { code: 'EE', name: 'Estonia', coordinates: [58.5953, 25.0136] },
  { code: 'ET', name: 'Ethiopia', coordinates: [9.1450, 40.4897] },
  { code: 'FJ', name: 'Fiji', coordinates: [-17.7134, 178.0650] },
  { code: 'FI', name: 'Finland', coordinates: [61.9241, 25.7482] },
  { code: 'FR', name: 'France', coordinates: [46.2276, 2.2137] },
  { code: 'GA', name: 'Gabon', coordinates: [-0.8037, 11.6094] },
  { code: 'GM', name: 'Gambia', coordinates: [13.4432, -15.3101] },
  { code: 'GE', name: 'Georgia', coordinates: [42.3154, 43.3569] },
  { code: 'DE', name: 'Germany', coordinates: [51.1657, 10.4515] },
  { code: 'GH', name: 'Ghana', coordinates: [7.9465, -1.0232] },
  { code: 'GR', name: 'Greece', coordinates: [39.0742, 21.8243] },
  { code: 'GF', name: 'Guyane française', coordinates: [3.9339, -53.1258] },
  { code: 'GD', name: 'Grenada', coordinates: [12.1165, -61.6790] },
  { code: 'GT', name: 'Guatemala', coordinates: [15.7835, -90.2308] },
  { code: 'GN', name: 'Guinea', coordinates: [9.9456, -9.6966] },
  { code: 'GW', name: 'Guinea-Bissau', coordinates: [11.8037, -15.1804] },
  { code: 'GY', name: 'Guyana', coordinates: [4.8604, -58.9302] },
  { code: 'HT', name: 'Haiti', coordinates: [18.9712, -72.2852] },
  { code: 'HN', name: 'Honduras', coordinates: [15.2000, -86.2419] },
  { code: 'HU', name: 'Hungary', coordinates: [47.1625, 19.5033] },
  { code: 'IS', name: 'Iceland', coordinates: [64.9631, -19.0208] },
  { code: 'IN', name: 'India', coordinates: [20.5937, 78.9629] },
  { code: 'ID', name: 'Indonesia', coordinates: [-0.7893, 113.9213] },
  { code: 'IR', name: 'Iran', coordinates: [32.4279, 53.6880] },
  { code: 'IQ', name: 'Iraq', coordinates: [33.2232, 43.6793] },
  { code: 'IE', name: 'Ireland', coordinates: [53.4129, -8.2439] },
  { code: 'IL', name: 'Israel', coordinates: [31.0461, 34.8516] },
  { code: 'IT', name: 'Italy', coordinates: [41.8719, 12.5674] },
  { code: 'CI', name: 'Ivory Coast', coordinates: [7.5400, -5.5471] },
  { code: 'JM', name: 'Jamaica', coordinates: [18.1096, -77.2975] },
  { code: 'JP', name: 'Japan', coordinates: [36.2048, 138.2529] },
  { code: 'JO', name: 'Jordan', coordinates: [30.5852, 36.2384] },
  { code: 'KZ', name: 'Kazakhstan', coordinates: [48.0196, 66.9237] },
  { code: 'KE', name: 'Kenya', coordinates: [-0.0236, 37.9062] },
  { code: 'KI', name: 'Kiribati', coordinates: [-3.3704, -168.7340] },
  { code: 'KW', name: 'Kuwait', coordinates: [29.3117, 47.4818] },
  { code: 'KG', name: 'Kyrgyzstan', coordinates: [41.2044, 74.7661] },
  { code: 'LA', name: 'Laos', coordinates: [19.8563, 102.4955] },
  { code: 'LV', name: 'Latvia', coordinates: [56.8796, 24.6032] },
  { code: 'LB', name: 'Lebanon', coordinates: [33.8547, 35.8623] },
  { code: 'LS', name: 'Lesotho', coordinates: [-29.6100, 28.2336] },
  { code: 'LR', name: 'Liberia', coordinates: [6.4281, -9.4295] },
  { code: 'LY', name: 'Libya', coordinates: [26.3351, 17.2283] },
  { code: 'LI', name: 'Liechtenstein', coordinates: [47.1660, 9.5554] },
  { code: 'LT', name: 'Lithuania', coordinates: [55.1694, 23.8813] },
  { code: 'LU', name: 'Luxembourg', coordinates: [49.8153, 6.1296] },
  { code: 'MG', name: 'Madagascar', coordinates: [-18.7669, 46.8691] },
  { code: 'MW', name: 'Malawi', coordinates: [-13.2543, 34.3015] },
  { code: 'MY', name: 'Malaysia', coordinates: [4.2105, 101.9758] },
  { code: 'MV', name: 'Maldives', coordinates: [3.2028, 73.2207] },
  { code: 'ML', name: 'Mali', coordinates: [17.5707, -3.9962] },
  { code: 'MT', name: 'Malta', coordinates: [35.9375, 14.3754] },
  { code: 'MH', name: 'Marshall Islands', coordinates: [7.1315, 171.1845] },
  { code: 'MR', name: 'Mauritania', coordinates: [21.0079, -10.9408] },
  { code: 'MU', name: 'Mauritius', coordinates: [-20.3484, 57.5522] },
  { code: 'MX', name: 'Mexico', coordinates: [23.6345, -102.5528] },
  { code: 'FM', name: 'Micronesia', coordinates: [7.4256, 150.5508] },
  { code: 'MD', name: 'Moldova', coordinates: [47.4116, 28.3699] },
  { code: 'MC', name: 'Monaco', coordinates: [43.7384, 7.4246] },
  { code: 'MN', name: 'Mongolia', coordinates: [46.8625, 103.8467] },
  { code: 'ME', name: 'Montenegro', coordinates: [42.7087, 19.3744] },
  { code: 'MA', name: 'Morocco', coordinates: [31.7917, -7.0926] },
  { code: 'MZ', name: 'Mozambique', coordinates: [-18.6657, 35.5296] },
  { code: 'MM', name: 'Myanmar', coordinates: [21.9162, 95.9560] },
  { code: 'NA', name: 'Namibia', coordinates: [-22.9576, 18.4904] },
  { code: 'NR', name: 'Nauru', coordinates: [-0.5228, 166.9315] },
  { code: 'NP', name: 'Nepal', coordinates: [28.3949, 84.1240] },
  { code: 'NL', name: 'Netherlands', coordinates: [52.1326, 5.2913] },
  { code: 'NZ', name: 'New Zealand', coordinates: [-40.9006, 174.8860] },
  { code: 'NI', name: 'Nicaragua', coordinates: [12.8654, -85.2072] },
  { code: 'NE', name: 'Niger', coordinates: [17.6078, 8.0817] },
  { code: 'NG', name: 'Nigeria', coordinates: [9.0820, 8.6753] },
  { code: 'KP', name: 'North Korea', coordinates: [40.3399, 127.5101] },
  { code: 'MK', name: 'North Macedonia', coordinates: [41.6086, 21.7453] },
  { code: 'NO', name: 'Norway', coordinates: [60.4720, 8.4689] },
  { code: 'OM', name: 'Oman', coordinates: [21.4735, 55.9754] },
  { code: 'PK', name: 'Pakistan', coordinates: [30.3753, 69.3451] },
  { code: 'PW', name: 'Palau', coordinates: [7.5150, 134.5825] },
  { code: 'PS', name: 'Palestine', coordinates: [31.9522, 35.2332] },
  { code: 'PA', name: 'Panama', coordinates: [8.5380, -80.7821] },
  { code: 'PG', name: 'Papua New Guinea', coordinates: [-6.3150, 143.9555] },
  { code: 'PY', name: 'Paraguay', coordinates: [-23.4425, -58.4438] },
  { code: 'PE', name: 'Peru', coordinates: [-9.1900, -75.0152] },
  { code: 'PH', name: 'Philippines', coordinates: [12.8797, 121.7740] },
  { code: 'PL', name: 'Poland', coordinates: [51.9194, 19.1451] },
  { code: 'PT', name: 'Portugal', coordinates: [39.3999, -8.2245] },
  { code: 'QA', name: 'Qatar', coordinates: [25.3548, 51.1839] },
  { code: 'RO', name: 'Romania', coordinates: [45.9432, 24.9668] },
  { code: 'RU', name: 'Russia', coordinates: [61.5240, 105.3188] },
  { code: 'RW', name: 'Rwanda', coordinates: [-1.9403, 29.8739] },
  { code: 'KN', name: 'Saint Kitts and Nevis', coordinates: [17.3578, -62.7830] },
  { code: 'LC', name: 'Saint Lucia', coordinates: [13.9094, -60.9789] },
  { code: 'VC', name: 'Saint Vincent and the Grenadines', coordinates: [12.9843, -61.2872] },
  { code: 'WS', name: 'Samoa', coordinates: [-13.7590, -172.1046] },
  { code: 'SM', name: 'San Marino', coordinates: [43.9424, 12.4578] },
  { code: 'ST', name: 'Sao Tome and Principe', coordinates: [0.1864, 6.6131] },
  { code: 'SA', name: 'Saudi Arabia', coordinates: [23.8859, 45.0792] },
  { code: 'SN', name: 'Senegal', coordinates: [14.4974, -14.4524] },
  { code: 'RS', name: 'Serbia', coordinates: [44.0165, 21.0059] },
  { code: 'SC', name: 'Seychelles', coordinates: [-4.6796, 55.4920] },
  { code: 'SL', name: 'Sierra Leone', coordinates: [8.4606, -11.7799] },
  { code: 'SG', name: 'Singapore', coordinates: [1.3521, 103.8198] },
  { code: 'SK', name: 'Slovakia', coordinates: [48.6690, 19.6990] },
  { code: 'SI', name: 'Slovenia', coordinates: [46.1512, 14.9955] },
  { code: 'SB', name: 'Solomon Islands', coordinates: [-9.6457, 160.1562] },
  { code: 'SO', name: 'Somalia', coordinates: [5.1521, 46.1996] },
  { code: 'ZA', name: 'South Africa', coordinates: [-30.5595, 22.9375] },
  { code: 'KR', name: 'South Korea', coordinates: [35.9078, 127.7669] },
  { code: 'SS', name: 'South Sudan', coordinates: [6.8770, 31.3070] },
  { code: 'ES', name: 'Spain', coordinates: [40.4637, -3.7492] },
  { code: 'LK', name: 'Sri Lanka', coordinates: [7.8731, 80.7718] },
  { code: 'SD', name: 'Sudan', coordinates: [12.8628, 30.2176] },
  { code: 'SR', name: 'Suriname', coordinates: [3.9193, -56.0278] },
  { code: 'SE', name: 'Sweden', coordinates: [60.1282, 18.6435] },
  { code: 'CH', name: 'Switzerland', coordinates: [46.8182, 8.2275] },
  { code: 'SY', name: 'Syria', coordinates: [34.8021, 38.9968] },
  { code: 'TW', name: 'Taiwan', coordinates: [23.6978, 120.9605] },
  { code: 'TJ', name: 'Tajikistan', coordinates: [38.8610, 71.2761] },
  { code: 'TZ', name: 'Tanzania', coordinates: [-6.3690, 34.8888] },
  { code: 'TH', name: 'Thailand', coordinates: [15.8700, 100.9925] },
  { code: 'TL', name: 'Timor-Leste', coordinates: [-8.8742, 125.7275] },
  { code: 'TG', name: 'Togo', coordinates: [8.6195, 0.8248] },
  { code: 'TO', name: 'Tonga', coordinates: [-21.1790, -175.1982] },
  { code: 'TT', name: 'Trinidad and Tobago', coordinates: [10.6918, -61.2225] },
  { code: 'TN', name: 'Tunisia', coordinates: [33.8869, 9.5375] },
  { code: 'TR', name: 'Turkey', coordinates: [38.9637, 35.2433] },
  { code: 'TM', name: 'Turkmenistan', coordinates: [38.9697, 59.5563] },
  { code: 'TV', name: 'Tuvalu', coordinates: [-7.1095, 177.6493] },
  { code: 'UG', name: 'Uganda', coordinates: [1.3733, 32.2903] },
  { code: 'UA', name: 'Ukraine', coordinates: [48.3794, 31.1656] },
  { code: 'AE', name: 'United Arab Emirates', coordinates: [23.4241, 53.8478] },
  { code: 'GB', name: 'United Kingdom', coordinates: [55.3781, -3.4360] },
  { code: 'US', name: 'United States', coordinates: [37.0902, -95.7129] },
  { code: 'UY', name: 'Uruguay', coordinates: [-32.5228, -55.7658] },
  { code: 'UZ', name: 'Uzbekistan', coordinates: [41.3775, 64.5853] },
  { code: 'VU', name: 'Vanuatu', coordinates: [-15.3767, 166.9592] },
  { code: 'VA', name: 'Vatican City', coordinates: [41.9029, 12.4534] },
  { code: 'VE', name: 'Venezuela', coordinates: [6.4238, -66.5897] },
  { code: 'VN', name: 'Vietnam', coordinates: [14.0583, 108.2772] },
  { code: 'YE', name: 'Yemen', coordinates: [15.5527, 48.5164] },
  { code: 'ZM', name: 'Zambia', coordinates: [-13.1339, 27.8493] },
  { code: 'ZW', name: 'Zimbabwe', coordinates: [-19.0154, 29.1549] }
];

export const getCountryByName = (name: string) => {
  return COUNTRIES.find(c => c.name.toLowerCase() === name.toLowerCase());
};

export const getCountryCoordinates = (name: string): [number, number] | null => {
  const country = getCountryByName(name);
  return country ? country.coordinates as [number, number] : null;
};
